export default __webpack_public_path__ + "static/media/mobileTshirt.706cd714.png";